import Vue from 'vue'
import App from './App.vue'

import Prodotto from './components/Prodotto.vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCopy , faTimes,  faChevronRight, faTag, faCopyright, faUtensils, faSearch, faHome, faArrowLeft, faSearchPlus } from '@fortawesome/free-solid-svg-icons'
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle'
import { faHatChef } from '@fortawesome/pro-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faGoogle, faCopy, faTimes, faChevronRight, faHatChef, faTag, faCopyright, faUtensils, faSearch, faHome, faArrowLeft, faSearchPlus )

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('prodotto', Prodotto);

Vue.config.productionTip = false
 
new Vue({
  render: h => h(App)
}).$mount('#app')
